
/**
 * バンドルミックスマッチ設定画面　出力VOクラス
 */
export class KYMW1308OutputModel {
}
